import { Action, EmptyAction } from './types';

export function isEmptyAction(action: Action): action is EmptyAction {
  return action.type === undefined;
}
